import {post} from '@/utils/request';
import {erpplatserver} from '@/utils/baseUrl';
//获取验证码
export async function getVerficationCode(params) {
    return post(erpplatserver+'/login/sendVerficationCode', params, true)
}
//验证码success
export async function getvalidatecode(params) {
    return post(erpplatserver+'/login/validateCode', params, true)
}
export async function getupdatePwd(params) {
    return post(erpplatserver+'/login/updatePwd', params, true)
}
export async function getUserLogin(params) {
    return post(erpplatserver+'/login/getUserLogin', params, true)
}